import React, { createContext, useMemo, useContext, useReducer } from "react";
import { notificationsAPI } from "../../services/notifications/notificactions.service";
import NotificationsReducer, {
  REQUEST_NOTIFICATIONS,
  SUCCESS_NOTIFICATIONS,
  FAILURE_NOTIFICATIONS,
} from "./notifications.reducer";

export const NotificationsDataContext = createContext<any>(null);

const initialValues = {
  recentNotification: {},
  notifications: [],
  loading: false,
};

const NotificationsDataProvider = ({ ...props }) => {
  const [state, dispatch] = useReducer(NotificationsReducer, initialValues);

  const getNotifications = async () => {
    dispatch({
      type: REQUEST_NOTIFICATIONS,
    });

    try {
      const res = await notificationsAPI();
      dispatch({
        type: SUCCESS_NOTIFICATIONS,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: FAILURE_NOTIFICATIONS,
      });
    }
  };

  const cleanNotifications = () => {
    dispatch({
      type: SUCCESS_NOTIFICATIONS,
      payload: [],
    });
  };

  const notificationsDataValue = useMemo(
    () => ({
      ...state,
      getNotifications,
      cleanNotifications,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [state]
  );

  return (
    <NotificationsDataContext.Provider
      value={notificationsDataValue}
      {...props}
    />
  );
};

export const useNotificationsDataContext = () =>
  useContext(NotificationsDataContext);

export default NotificationsDataProvider;
